module.exports = __webpack_public_path__ + "img/home1-4.47f5cbac.jpg";